export enum SearchPeriod {
  LastMonth = 'Last Month',
  LastThreeMonths = 'Last Three Months',
  LastYear = 'Last Year',
  Custom = 'Custom'
}
